import axios from "axios";

export default function getSvgComponents({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({ url, fill }) => {
    return axios.get(url).then(({ data }) => {
      const viewBox = data.match(/viewBox="([^"]*)"/)[1];
      const paths = data.match(/<path\b([\s\S]*?)\/>/g);
      return { fill, viewBox, paths };
    });
  };
}
